import React from 'react';

export default props => {
  const renderOptions = () => {
    const options = [];
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 15) {
        const hhmm = `0${h}`.slice(-2) + ':' + `0${m}`.slice(-2);
        options.push(
          <option key={hhmm} value={hhmm} selected={props.value === hhmm}>
            {hhmm}
          </option>
        );
      }
    }
    return options;
  };

  const onChangeItem = e => {
    const time = e.target.value;
    props.onChange(time);
  };

  return (
    <>
      <select onChange={onChangeItem} className={props.className} disabled={props.disabled} name={props.name}>
        {renderOptions()}
      </select>
    </>
  );
};
